export default {
  overview: {
    title: "Files",
    subtitle: "Every stored file in one place.",
    search: {
      placeholder: "Search folders and files",
      results: "Search results",
      count: "{count} matches",
    },
    due_filter: {
      label: "Valid until",
      options: {
        all: "All",
        expired: "Expired",
        expiring: "Expiring soon",
        valid: "Valid",
      },
    },
    path: {
      label: "Path",
      root: "Files",
    },
    storage: {
      used: "{used} of {max}",
      used_uncapped: "{used} used",
      // Both only in the meter's tooltip.
      free: "{size} free",
      full: "No storage left",
    },
    folder_summary: "{files} files · {size}",
    folder_files: "{count} files",
    open_owner: "Open record",
    upload: {
      action: "Upload",
      drop: "Drop into “{folder}”",
      drop_blocked: "Files cannot be dropped here",
    },
    menu: {
      label: "More actions",
      preview: "Preview",
      edit: "Edit",
      details: "View details",
      open: "Open",
    },
    table: {
      headers: {
        name: "Name",
        location: "Folder",
        size: "Size",
        uploaded: "Uploaded",
        due: "Valid until",
        tags: "Tags",
      },
      groups: {
        folders: "Folders",
        files: "Files",
      },
      sort: {
        ascending: "sort ascending",
        descending: "sort descending",
      },
    },
    empty: {
      root: "No files yet.",
      folder: "This folder holds no files.",
      search: "Nothing found.",
      filtered: "No files with this expiry status.",
    },
  },
  types: {
    constructionreport: "[[Cr.pl]]",
    hourlywagereport: "[[Hwr.pl]]",
    // Not used by the file browser: the Protokoll tab names references to record kinds that have no
    // page of their own with these.
    hourlywageinvoice: "[[Hwi.pl]]",
    contactposition: "Contact roles",
  },
}
